import {SurveyFormModel} from "../model/SurveyFormModel";
import {SurveyFormListOptions} from "../model/SurveyFormListOptions";
import {BaseDataProvider} from "./BaseDataProvider";
import {SurveyCampaignListOptions} from "../model/SurveyCampaignListOptions";
import {SurveyCampaignModel} from "../model/SurveyCampaignModel";
import {PaginateOptions} from "../../../agent";
import {Patient, SpecialGroup} from "../../dashboard";
import {OldBaseDataProvider} from "./OldBaseDataProvider";

export class PatientsDataProvider
    extends OldBaseDataProvider<Patient, PaginateOptions> {
    constructor() {
        super(`/patient`);
    }

    keyProperty: string = "_id";
}